var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9994 5.66357C18.3514 5.66357 5.66602 18.3484 5.66602 33.9969C5.66602 49.6453 18.3514 62.3302 33.9994 62.3302C49.6473 62.3302 62.3327 49.6453 62.3327 33.9969C62.3327 18.3484 49.6473 5.66357 33.9994 5.66357ZM33.9994 11.3302C46.5179 11.3302 56.666 21.4792 56.666 33.9969C56.666 46.5145 46.5179 56.6635 33.9994 56.6635C21.4808 56.6635 11.3327 46.5145 11.3327 33.9969C11.3327 21.4792 21.4808 11.3302 33.9994 11.3302Z",
    fill: "#40C36D",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.307 25.5C44.5845 25.5 43.828 25.7437 43.2755 26.2962L32.7638 36.9211C32.0357 37.6521 31.3047 37.5161 30.7323 36.6576L27.9076 32.4076C27.0406 31.1043 25.23 30.7417 23.9323 31.6087C22.6347 32.4785 22.272 34.2918 23.1362 35.5923L25.9639 39.8423C28.5139 43.6786 33.4892 44.1659 36.739 40.9076L47.3385 30.3705C48.4407 29.2626 48.4407 27.404 47.3385 26.2962C46.786 25.7437 46.0295 25.5 45.307 25.5Z",
    fill: "#40C36D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/ToastSuccessIcon.dc016fd6.svg";
export { ForwardRef as ReactComponent };